import { DialogDimension } from '@office-start/metaos-hub-sdk';
import { clampDimension } from './clampDimension';
/**
 * Calculates correct height based off of given dimensions
 *
 * @param height - This attribute can be a number representing the task module's height in pixels, or small, medium,
 *  or large. For more information, see {@link https://docs.microsoft.com/en-us/microsoftteams/platform/task-modules-and-cards/task-modules/invoking-task-modules#task-module-sizing Task Module Sizing }.
 * @returns calculated hight as a `number`
 */
export const getHeight = (windowHeight, height) => {
    if (!height)
        return DialogDimension.Medium;
    if (typeof height === 'number') {
        return clampDimension(windowHeight, height);
    }
    switch (height) {
        case DialogDimension.Small:
            return windowHeight * 0.2;
        case DialogDimension.Medium:
            return windowHeight * 0.5;
        case DialogDimension.Large:
            return windowHeight * 0.66;
    }
};
//# sourceMappingURL=getHeight.js.map